import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Chip,
  FormHelperText,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { ADD_UPDATE_LOCATION_URL } from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import {
  deCryptFun,
  enCryptFun,
  CustomMessage,
} from "../comman/CustomFunction";
import API from "../comman/API";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useFormik } from "formik";
import * as Yup from "yup";
import { stateData } from "../comman/Constant";
import { useSelector } from "react-redux";
import CustomLoader from "../comman/CustomLoader";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const initialValues = {
  locationId: 0,
  county: "",
  taxRate: "",
  state: 0,
  country: "United States of America",
  active: true,
};
export default function AddNewLocation(props) {
  const { open, handleClose, id, locationRowDetailValue } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    state: Yup.string().test(
      "state",
      "State is required",
      (value) => value != 0
    ),
    county: Yup.string()
      .required("County is required")
      .min(3, "County name must be at least 3 characters long.")
      .max(50, "County name cannot exceed 50 characters."),
    taxRate: Yup.number()
      .required("Day Rate is required")
      .typeError("Data Rate should be a number"),
    // .test(
    //   "is-valid-tax-rate",
    //   "Day rate should be a number with one digit before the decimal point and up to four digits after the decimal point",
    //   (value) => /^([0-9]{1})(\.[0-9]{1,4})?$/.test(value)
    // ),
  });

  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      AddUpdateLocationFun(values);
    },
  });
  const AddUpdateLocationFun = async (values) => {
    setLoading(true);
    const { locationId, county, taxRate, state, country, active } = values;

    let d1 = {
      projectId: parseInt(id),
      locationId,
      county,
      taxRate: parseFloat(taxRate).toFixed(2),
      state: state ? Number(state) : 0,
      country,
      active: active == true ? 1 : 0,
    };
    const config = {
      method: "POST",
      url: ADD_UPDATE_LOCATION_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(d1)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setLoading(false);
        handleClose({
          status: "success",
          message: parsedResponse?.message,
          // d1.locationId
          //   ? "New Location Updated Successfully"
          //   : "New Location Added Successfully",
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);

        handleClose({
          status: "error",
          message: v.message,
        });
        setLoading(false);
      }
      setLoading(false);
    } finally {
      setLoading(false);
      // setFlag(true);
    }
  };

  const handleChangeDecimalValue = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/[^\d.]/g, "");
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return;
    }

    if (/^0[0-9]+/.test(sanitizedValue)) {
      const correctedValue = sanitizedValue.replace(/^0+/, "");
      setValues({ ...values, [name]: correctedValue });
      return;
    }

    const decimalParts = sanitizedValue.split(".");
    if (decimalParts[1] && decimalParts[1].length > 2) {
      return;
    }

    setValues({ ...values, [name]: sanitizedValue });
  };

  const handleChangeCountyValue = (event) => {
    const { name, value } = event.target;

    // Remove leading spaces
    let formattedValue = value.trim();

    // Ensure only alphabetic characters
    formattedValue = formattedValue.replace(/[^a-zA-Z]/g, "");

    setValues({ ...values, [name]: formattedValue });
  };

  useEffect(() => {
    if (locationRowDetailValue.LocationID) {
      setValues((prevValues) => ({
        ...prevValues,
        locationId: locationRowDetailValue.LocationID,
        county: locationRowDetailValue.County,
        taxRate: locationRowDetailValue.TaxRate,
        state: locationRowDetailValue.State,
        //country: locationRowDetailValue.Country,
        active: locationRowDetailValue.Active,
      }));
    }
  }, [locationRowDetailValue]);

  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      handleChange(e);
    }
  };

  const handleAlphabeticChange = (e) => {
    const { name, value } = e.target;

    // Trim leading spaces
    let trimmedValue = value.trimStart();

    // Check if the trimmed value is valid and does not start with a space
    if (
      /^[a-zA-Z\s]*$/.test(trimmedValue) &&
      trimmedValue.length <= 50 &&
      !trimmedValue.startsWith(" ")
    ) {
      handleChange(e);
    }
  };

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">Add New Location</Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <Stack
            direction="row"
            alignItems="baseline"
            justifyContent="space-between"
            spacing={3}
          >
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">Country:</p>
              <Input
                name="country"
                id="country"
                disabled
                value={values.country}
                placeholder="Enter Country"
                onChange={handleChange}
                error={errors.country && touched.country}
                helperText={
                  errors.country && touched.country ? errors.country : ""
                }
              />
              <FormHelperText error={true}>
                {errors.country && touched.country ? errors.country : ""}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ width: "100%" }} variant="outlined">
              <p className="label">State:</p>
              <Select
                sx={{
                  ".MuiSelect-select": {
                    color:
                      values.state === 0
                        ? "#898989 !important"
                        : "#212121 !important",
                  },
                }}
                name="state"
                value={values.state}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                error={errors.state && touched.state}
                helperText={errors.state && touched.state ? errors.state : ""}
              >
                <MenuItem selected={true} disabled={true} value={0}>
                  Select State
                </MenuItem>
                {stateList &&
                  JSON.parse(stateList).data.map((item) => (
                    <MenuItem key={item.countyId} value={item.countyId}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText error={true}>
                {errors.state && touched.state ? errors.state : ""}
              </FormHelperText>
            </FormControl>
          </Stack>
          <Stack
            sx={{ mb: "5px" }}
            direction="row"
            alignItems="baseline"
            justifyContent="space-between"
            spacing={3}
          >
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">County:</p>
              <Input
                name="county"
                id="county"
                value={values.county}
                placeholder="Enter County"
                onChange={handleAlphabeticChange}
                error={errors.county && touched.county}
                helperText={
                  errors.county && touched.county ? errors.county : ""
                }
              />
              <FormHelperText error={true}>
                {errors.county && touched.county ? errors.county : ""}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ width: "100%" }} variant="standard">
              <p
                className="label"
                style={{ display: "flex", alignItems: "center" }}
              >
                Day Rate:
                <Tooltip
                  className="project-tooltip"
                  title="This is the default rate when used invoicing this customer for billing logged at this location"
                  arrow
                >
                  <IconButton sx={{ p: 0 }}>
                    <HelpOutlineIcon sx={{ width: "15px", height: "15px" }} />
                    {/* <img src="path/to/question-mark.png" alt="info" style={{ width: '20px', height: '20px' }} /> */}
                  </IconButton>
                </Tooltip>
              </p>
              <Input
                className="dollar-field"
                name="taxRate"
                id="taxRate"
                value={values.taxRate}
                placeholder="Enter Day Rate"
                onChange={handleNumericChange}
                error={errors.taxRate && touched.taxRate}
                helperText={
                  errors.taxRate && touched.taxRate ? errors.taxRate : ""
                }
                startAdornment={
                  <InputAdornment position="start">
                    <span className="dollar-icon">$</span>
                  </InputAdornment>
                }
              />
              <FormHelperText error={true}>
                {errors.taxRate && touched.taxRate ? errors.taxRate : ""}
              </FormHelperText>
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "26px 34px", pt: "0px" }}
        >
          <Button className= {loading ? 'disable-filter-btn' : "filter-btn"}  type="submit" disabled={loading}>
            {loading && (
              <CircularProgress
                color={"inherit"}
                size={10}
                sx={{ marginRight: "3px" }}
              />
            )}
            Save
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
